import { Box } from "@mui/material";
import Chart from "react-apexcharts";
import { CHART_HEIGHT } from "../constants";

interface BidsChartProps {
  options: ApexCharts.ApexOptions;
  series: Array<{ name: string; data: number[] }>;
}

export const BidsChart = ({ options, series }: BidsChartProps) => {
  return (
    <Box id="bids-bar-chart">
      <Chart options={options} series={series} type="bar" height={CHART_HEIGHT} />
    </Box>
  );
};
